import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3a7 7 0 0 1 7 7v4l-3 -3","key":"svg-0"}],["path",{"d":"M22 11l-3 3","key":"svg-1"}],["path",{"d":"M8 15.5l-5 -3l5 -3l5 3v5.5l-5 3z","key":"svg-2"}],["path",{"d":"M3 12.5v5.5l5 3","key":"svg-3"}],["path",{"d":"M8 15.545l5 -3.03","key":"svg-4"}]]

const IconRotate3d = createReactComponent('outline', 'rotate-3d', 'Rotate3d', __iconNode);

export default IconRotate3d;